import ScheduleDetail from "../../components/customer/schedule/schedule-detail";

const ScheduleDetailPage = () => {
  return <ScheduleDetail />;
};

export default ScheduleDetailPage;

